module.exports = __webpack_public_path__ + "img/iso6336-5-2003_fig13b.60f27bd8.png";